<template>
    <Resize id="app" class="app-layout" :class="{mobile: $root.isMobile, 'open-popup' : popup!='' || $route.path=='/picnic'}"  ref="resize">

        <div class="header" :class="{'hide' : openMenu}">
            <a href="https://www.afisha.ru/" @click="gaEvents('main','click','logo afisha')" target="_blank" class="logo-a"></a>
            <a href="/" @click="gaEvents('main','click','main')" class="logo-b"></a>
            <a href="https://www.weleda.ru/?utm_source=afisha&utm_medium=logo&utm_term=range&utm_content=main_page&utm_campaign=weleda_afisha_sp_summer_2018" @click="gaEvents('main','click','logo weleda')" target="_blank" class="logo">
                <Logo></Logo>
            </a>
        </div>

        <a href="#" class="open-menu" :class="{'open' : openMenu}" @click.prevet="toggleMenu">
            <span></span>
        </a>

        <menu-app class="menu" @closeMenu="toggleMenu"></menu-app>

        <div class="center" @click="closeShare">
            <transition name="slide-fade">
                <router-view ref="page" ></router-view>
            </transition>
        </div>
        <div class="social-block">
            <ul class="social-list" v-if="openSocial">
                <li>
                    <share-link network="fb" url="http://weleda.afisha.ru/" @click.native="gaEvents('main','click','fb')" class="icon">
                        <fb></fb>
                    </share-link>
                </li>
                <li>
                    <share-link network="vk" url="http://weleda.afisha.ru/" @click.native="gaEvents('main','click','vk')" class="icon">
                        <vk></vk>
                    </share-link>
                </li>
                <li>
                    <share-link network="ok" url="http://weleda.afisha.ru/" @click.native="gaEvents('main','click','ok')" class="icon">
                        <ok></ok>
                    </share-link>
                </li>
                <li>
                    <share-link network="tw" url="http://weleda.afisha.ru/" @click.native="gaEvents('main','click','tw')" class="icon">
                        <tw></tw>
                    </share-link>
                </li>
            </ul>
            <a href="#" class="open-social" @click.prevent="toggleSocial">
                <opensocial></opensocial>
            </a>
        </div>

    </Resize>
</template>

<script>
    import {TweenMax} from 'gsap'

    import Resize from '@/components/common/Resize';
    import Menu from '@/components/common/Menu';
    import Logo from './assets/svg/logo.svg';

    import opensocial from './assets/svg/social.svg';
    import icons from '@/assets/svg/social';
    import vk from '@/assets/svg/social/vk.svg';
    import fb from '@/assets/svg/social/fb-new.svg';

    import Helpers from '@/tools/Helpers';

    export default {
        name: 'app',
        data() {
            return {
                openMenu: false,
                openSocial: false,
            }
        },

        components: {
            vk: icons.vk,
            fb,
            ok: icons.ok,
            googleplus: icons.googleplus,
            tw: icons.tw,
            Logo,
            'menu-app': Menu,
            Resize,
            opensocial,
        },

        computed: {
            popup() {
                return this.$store.getters['GET_POPUP'];
            }
        },

        mounted() {

        },

        methods: {

            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },

            closeShare() {
                this.openSocial = false;
            },
            toggleMenu(){
                this.openMenu=!this.openMenu
            },
            toggleSocial(){
                this.openSocial=!this.openSocial
                this.gaEvents('main','click','heart');
            },

        },
    };
</script>

<style>
    .slide-fade-enter-active {
        transition: opacity 3s ease;
        opacity: 0;
    }
    .slide-fade-leave-active {
        transition: opacity 2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        opacity: 1;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transition: all 3s ease;
        opacity: 0;
    }

</style>





// WEBPACK FOOTER //
// App.vue?4fcd9a1d